import React from 'react'
import { onAnchorTriggerKey } from '../../utils'

interface HeaderCellState {
  sortDir: string
  sortClassName: string
}

export type HeaderCellProps = {
  heading: string
}

export class HeaderCell extends React.Component<
  HeaderCellProps,
  HeaderCellState
> {
  state = {
    sortDir: 'none',
    sortClassName: 'fas fa-sort'
  }

  handleClick = () => {
    let { sortDir, sortClassName } = this.state

    if (sortDir === 'none' || sortDir === 'desc') {
      sortDir = 'asc'
      sortClassName = 'fas fa-sort-up'
    } else if (sortDir === 'asc') {
      sortDir = 'desc'
      sortClassName = 'fas fa-sort-down'
    }

    this.setState({ sortDir, sortClassName })
  }

  render() {
    const { heading } = this.props
    const { sortClassName } = this.state

    return (
      <div
        onKeyDown={onAnchorTriggerKey(this.handleClick)}
        onClick={this.handleClick}
        tabIndex={0}
        role="button"
      >
        {heading}&nbsp;&nbsp;
        <i className={sortClassName} />
      </div>
    )
  }
}
